import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './ProfilePage.css';

import { FaInstagram, FaMicrophone, FaTv } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';

const ProfilePage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div>
      <div className="profile-page">
        <div className="profile-image-container" data-aos="fade-up">
          <img src="/Image/Coachnachiketh.png" alt="Coach Rajan" className="profile-image" />
        </div>
        <div className="profile-content" data-aos="fade-up" data-aos-delay="200">
          <p>Hi Guys, I’m  <span className='coachrajan'>Coach Nachiketh</span> , a fitness and nutrition coach dedicated to helping people achieve their health goals</p>
        </div>
      </div>

      <div className="achievements-container" data-aos="fade-up" data-aos-delay="400">
        <p>With 8+ years of coaching experience.</p>
        {/* <p>Recognized and appreciated by many, including:</p> */}
        <p>
        I’ve worked with over 6,000 professionals and entrepreneurs (aged 30–50) to lose fat, build healthy habits, and take control of their health—all while balancing their busy lifestyles
        </p>
      </div>
    </div>
  );
};

export default ProfilePage;
